<template>
  <div id="app">
    <router-view />
    <!-- <Home></Home> -->
    <div class="mask" :style="{ height: scrollerHeight }" v-show="showLoading" ref="mask">
      <LoadingCSS class="mask_img"></LoadingCSS>
    </div>
  </div>
</template>

<script>
import LoadingCSS from './components/common/loading.vue'
// import { Notification } from 'element-ui'
// import Home from './views/home/Home.vue']

export default {
  data() {
    return {
      Authority: this.AuthorityFilter(this.$route.path),
      productType: []
    }
  },
  components: {
    LoadingCSS
  },
  mounted() {
    // this.handleUseIPGetAddress()
    const that = this
    window.addEventListener('unload', this.saveUserData) // 监听刷新时
    // 监听浏览器大小
    window.onresize = function() {
      const clientHeight = `${document.documentElement.clientHeight}`
      const clientWidth = `${document.documentElement.clientWidth}`
      that.$store.commit('set_clientHeight', clientHeight)
      that.$store.commit('set_clientWidth', clientWidth)
    }
    this.$store.commit('set_clientHeight', `${document.documentElement.clientHeight}`)
    this.$store.commit('set_clientWidth', `${document.documentElement.clientWidth}`)

    // 获取当前未完成的待办事项数
    this.$bus.$on('getTodoNumber', this.getTodoNumber)
    // 获取当前未完成的问题汇总数
    this.$bus.$on('getQuestionNumber', this.getQuestionNumber)
  },
  methods: {
    // 根据ip获取地址（搜狐接口的地址不太对劲）
    async handleUseIPGetAddress() {
      const { data: res } = await this.$http.get('/json', {
        headers: {
          ipSearch: true
        }
      })
      this.$store.commit('set_ipAndAddress', { ip: res.ip, address: res.province + res.city })
    },
    // 获取及缓存IP地址、物理地址信息
    // async handleGetIpAndAddress() {
    //   // 获取IP地址，但是会被广告插件拦截
    //   const loadScript = src => {
    //     return new Promise(resolve => {
    //       const script = document.createElement('script')
    //       const head = document.getElementsByTagName('head')[0]
    //       script.type = 'text/javascript'
    //       script.charset = 'UTF-8'
    //       script.src = src
    //       if (script.addEventListener) {
    //         script.addEventListener(
    //           'load',
    //           function () {
    //             resolve()
    //           },
    //           false
    //         )
    //       } else if (script.attachEvent) {
    //         script.attachEvent('onreadystatechange', function () {
    //           const target = window.event.srcElement
    //           if (target.readyState == 'loaded') {
    //             resolve()
    //           }
    //         })
    //       }
    //       head.appendChild(script)
    //     })
    //   }
    //   await loadScript(`http://pv.sohu.com/cityjson?ie=utf-8`)
    //   if (!this.$store.state.ipAndAddress.ip) {
    //     this.$store.commit('set_ipAndAddress', {
    //       ip: window.returnCitySN['cip'],
    //       address: window.returnCitySN['cname']
    //     })
    //   }
    // },
    saveUserData() {
      this.$store.dispatch('shutloader')
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    },

    // 获取当前未完成的待办事项数
    async getTodoNumber() {
      const { data: res } = await this.$http.get('/Common/YKToDoList/list', {
        params: {
          type: '未完成'
        }
      })
      if (!res.isSuccess) {
        return false
      }
      const len = res.data.rows.length
      if (len > 0) {
        this.$notify({
          title: '待办事项',
          dangerouslyUseHTMLString: true,
          message: `您还有「<span style="color:red">${len}</span>」条未完成的<strong>「待办事项」</strong>请及时处理`,
          position: 'bottom-right',
          // 不关闭消息
          duration: 7000,
          type: 'warning'
        })
      }
    },
    // 获取下拉框值（产品版本）
    async getProductVersion() {
      const { data: res } = await this.$http.get('/Common/ProductVersionSet/select-item')
      if (!res.isSuccess) {
        return false
      }
      this.productType = []
      res.data.forEach(item => {
        if (item.code === 'ProductionType') {
          this.productType.push(item.value)
        }
      })
    },
    // 获取当前未完成的问题汇总数
    async getQuestionNumber() {
      // 先获取版本，才能接着往下获取各版本的问题汇总数
      await this.getProductVersion()

      // 获取问题汇总数
      for (let menuArgs of this.productType) {
        const { data: res } = await this.$http.post('/Common/YKCase/list', {
          menuArgs,
          // [default: 过滤本人；不写default则全部查询]
          sqlTitle: 'default',
          // 权限
          seeType: 4
        })
        if (res.isSuccess) {
          const len = res.data.rows.length
          if (len > 0) {
            this.$notify({
              title: '问题汇总',
              dangerouslyUseHTMLString: true,
              message: `您还有「<span style="color:red">${len}</span>」条未完成的<strong>「${menuArgs}」</strong>问题汇总，请及时处理`,
              position: 'bottom-right',
              // 不关闭消息
              duration: 7000,
              type: 'warning'
            })
          }
        }
      }
    }
  },
  computed: {
    scrollerHeight() {
      return this.$store.state.clientHeight + 'px'
    },
    showLoading() {
      return this.$store.state.showLoading > 0
    }
  }
}
</script>
<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  width: 100%;
  height: 100%;
}
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  color: white;
}
.mask_img {
  z-index: 99999;
  position: fixed;
  left: 50%;
  top: 50%;
}
#vxeDelete {
  color: red;
}
</style>
